import { useFeatureFlag } from '@trello/feature-flag-client';
import { currentLocale, languageParts } from '@trello/locale';
import { useTemplatePickerContainerGalleryQuery } from 'app/src/components/CreateBoardFromTemplate/TemplatePickerContainerGalleryQuery.generated';
import { useTemplatePickerContainerMyTemplatesQuery } from 'app/src/components/CreateBoardFromTemplate/TemplatePickerContainerMyTemplatesQuery.generated';
import { useTemplatePickerStarredQuery } from 'app/src/components/CreateBoardFromTemplate/TemplatePickerStarredQuery.generated';

interface UseTemplatePickerContainerPreloaderProps {
  skip?: boolean;
}

export const useTemplatePickerPreloader = ({
  skip = false,
}: UseTemplatePickerContainerPreloaderProps) => {
  const topTemplates: { [key: string]: string[] } = useFeatureFlag(
    'teamplates.web.create-flow-top-templates',
    {},
  );

  const language = languageParts(currentLocale).language;
  let topTemplatesList: string[] = [];

  if (topTemplates[currentLocale]) {
    topTemplatesList = topTemplates[currentLocale];
  } else if (topTemplates[language]) {
    topTemplatesList = topTemplates[language];
  } else {
    topTemplatesList = topTemplates['en'];
  }

  const templatePickerContainerGalleryQueryResult = useTemplatePickerContainerGalleryQuery(
    {
      variables: {
        boardIds: topTemplatesList,
      },
      skip: skip,
    },
  );

  const templatePickerContainerMyTemplatesQueryResults = useTemplatePickerContainerMyTemplatesQuery(
    {
      skip: skip,
    },
  );

  const templatePickerStarredQueryResults = useTemplatePickerStarredQuery({
    skip: skip,
  });

  return {
    templatePickerContainerGalleryQueryResult,
    templatePickerContainerMyTemplatesQueryResults,
    templatePickerStarredQueryResults,
  };
};
